import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../App/Helpers/callApi";
import Signifier from "../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { editMasterCache, getMasterCache } from "./MasterCacheService";

function MasterCachePage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [cacheData, setCacheData] = useState(false);
  const [minutes, setMinutes] = useState("");

  function saveEventSearch() {
    let data = {
      ClientId: selectCareersClient.id,
      IsDataCached: cacheData,
      CacheTime: minutes,
    };

    callAPI(
      editMasterCache(data),
      "Master Cache Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getMasterCache(selectCareersClient.id).then((response) => {
        setMinutes(response.cacheTime === null ? "" : response.cacheTime);
        setCacheData(response.isDataCached);
      });
    });
  }

  useEffect(() => {
    if (selectCareersClient !== null) {
      getMasterCache(selectCareersClient.id).then((response) => {
        setMinutes(response.cacheTime === null ? "" : response.cacheTime);
        setCacheData(response.isDataCached);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Master Cache
        </h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      style={{ marginTop: "10px" }}
                      className={classes.copy}
                      control={
                        <Checkbox
                          color="primary"
                          checked={cacheData}
                          onChange={() => setCacheData(!cacheData)}
                        />
                      }
                      label="Cache Data"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Cache Time in Minutes"
                      label="Cache Time in Minutes"
                      variant="standard"
                      fullWidth
                      required
                      type="number"
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={minutes}
                      onChange={(e) => setMinutes(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => saveEventSearch()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default MasterCachePage;
